function format(date) {
  var year = date.getFullYear();
  var month = ('0' + (date.getMonth() + 1)).slice(-2);
  var day = ('0' + (date.getDate())).slice(-2);
  return (year + '-' + month + '-' + day);
}
module.exports = format;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@holiday-jp/holiday_jp/lib/format.js
// module id = pgGx
// module chunks = 0